import type { BuiltInSegmentItemType } from '@/pages/activityManage/create/data.d';
import type {
  DeliverTypeEnum,
  ToTabsEnum,
} from '@/pages/activityWhatsApp/create/data.d';
/** 活动状态枚举 */
export enum CampaignStatus {
  /** 草稿状态 */
  DRAFT = 'DRAFT',
  /** 已排期状态 */
  SCHEDULED = 'SCHEDULED',
  /** 进行中状态 */
  ONGOING = 'ONGOING',
  /** 已完成状态 */
  COMPLETED = 'COMPLETED',
  /** 已暂停状态 */
  PAUSED = 'PAUSED',
  /** 已取消状态 */
  CANCELLED = 'CANCELLED',
  /** 错误 */
  ERROR = 'ALL_USER_WAIT_SEND',
}

export enum BusinessCode {
  TEST = '10000',
}

export interface TaskItem {
  id: number;
  name: string;
  description: string;
  status: CampaignStatus;
  fileName: string;
  businessCode: BusinessCode;
  totalMessages: number;
  successMessages: number;
  failedMessages: number;
  startTime: Date;
  endTime: Date;
  templateInfo: string;
  tokensPerSecond: number;
  bucketSize: number;
  deliverTime: string;
  schedulerJobName: string;
  segmentId: string;
  segmentType: string;
  createdAt: Date;
  updatedAt: Date;
}

// 请求参数--------------------------------

/** 获取列表参数 */
export interface ListParams {
  name?: string;
  status?: CampaignStatus;
  pageNum?: number;
  pageSize?: number;
  includeProgress?: boolean; // 查询统计指标值
  statusList?: string[]; // 查询指定状态活动数据
  createdAtStart?: string;
  createdAtEnd?: string;
}

/** 创建任务参数 */
export interface CreateTaskParamsItem {
  languageCode: string;
  templateName: string;
  templateId: string;
}

// 创建campaign
export interface CreateCampaignParams {
  name: string;
  description?: string;
  whatsAppAccountId: number;
  createTaskParamsList?: CreateTaskParamsItem[] | null;
  segmentId?: number | null;
  segmentType?: ToTabsEnum;
  segmentName?: string;
  deliverType: DeliverTypeEnum;
  deliverTime?: string | null;
  deliverTimeLocal?: string | null;
  defaultLanguage: string;
  totalUserCount?: number;
  builtInSegmentList?: Partial<BuiltInSegmentItemType>[] | null;
  builtInSegmentUuid?: string | null;
}

// 响应结果--------------------------------

/** 活动列表Item */
export interface ActivityListItem {
  id: number;
  name: string;
  /** 活动描述 */
  description: string;
  /** 游戏ID */
  gameId: string;
  status: CampaignStatus;
  /** 发送者手机号 */
  senderPhoneNumber: string;
  /** 创建任务参数列表 */
  createTaskParamsList: string;
  /** 是否删除 */
  deletedState: boolean;
  /** 任务列表 */
  tasks: TaskItem[];
  /** 最后更新时间 */
  updatedAt: Date;
  /** 创建时间 */
  createdAt: Date;
  /** 创建人 */
  createdBy: string;
  /** 最后更新人 */
  lastUpdatedBy: string;
  /** 开始时间 */
  startTime: Date;
}

export interface ListRes {
  data: {
    data: ActivityListItem[];
    pageInfo: {
      pageNum: number;
      pageSize: number;
      total: number;
      totalPages: number;
    };
  };
}

// campaign
export interface Campaign {
  id: number;
  name: string;
  description?: string;
  gameId: string;
  status: CampaignStatus;
  createTaskParamsList: CreateTaskParamsItem[];
  deletedState: boolean;
  tasks: TaskItem[];
  lastUpdatedBy: string;
  createdBy: string;
  createdAt: Date;
  updatedAt: Date;
  whatsAppAccount: {
    id: number;
    whatsAppAccountName: string;
    senderPhoneNumber: string;
  };
  segmentId: number;
  segmentName: string;
  segmentType: ToTabsEnum;
  deliverType: DeliverTypeEnum;
  deliverTime: string;
  totalUserCount?: number;
  startTime: string;
  builtInSegmentList?: BuiltInSegmentItemType[] | null;
  builtInSegmentUuid?: string | null;
}

export interface CreateCampaignRes {
  name: string;
  senderPhoneNumber: string;
  createTaskParamsList: CreateTaskParamsItem[];
}

/** 商户发起会话24小时限制等级枚举 */
export enum WhatsAppAccountTier {
  /** 50 位客户/24小时 */
  TIER_50 = 'TIER_50',
  /** 250 位客户/24小时 */
  TIER_250 = 'TIER_250',
  /** 1千位客户/24小时 */
  TIER_1K = 'TIER_1K',
  /** 1万位客户/24小时 */
  TIER_10K = 'TIER_10K',
  /** 10万位客户/24小时 */
  TIER_100K = 'TIER_100K',
  /** 不适用 */
  TIER_UNLIMITED = 'TIER_UNLIMITED',
}

// senderPhoneNumber
export interface SenderPhoneNumberRes {
  id: number;
  whatsAppAccountName: string;
  senderPhoneNumber: string;
  currentLimit?: WhatsAppAccountTier;
}

// 国家编号
export enum CountryCodeEnum {
  KOREA_TIMEZONE_LIMIT = 410,
}
